var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBebeHomme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "82px",
    viewBox: "0 0 74 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BebeHomme") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BebeHomme",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6499541,-0.77184001 C31.1147645,-0.973382526 31.6588366,-1.04451507 32.2538858,-0.97238709 C33.2557547,-0.850947094 34.4383301,-0.300778526 35.5244471,0.584410132 C37.3423428,2.06600057 38.8591549,4.45339014 38.8591549,6.94798142 C38.8591549,8.15852841 38.6308885,9.31537845 38.2165564,10.3779978 C42.650144,12.9911604 46.0680576,17.5894477 47.5539076,23.1697628 L47.589,23.307 L47.712391,23.3293079 C48.8910397,23.5761158 49.9073914,24.3906127 50.5893728,25.615965 L50.7132839,25.850495 C51.3456722,27.1123749 51.6328855,28.7665923 51.3960903,30.5195619 C51.1902397,32.0434526 50.6238536,33.3832584 49.8612304,34.3845842 C49.1678436,35.2950026 48.3122576,35.9256699 47.4053365,36.2193819 C46.5228553,39.2468838 45.0670144,41.9704043 43.1901326,44.2215177 C47.9116626,45.8953385 51.9119601,48.4283158 54.8691905,51.5328979 C58.3996561,55.2392782 60.4500413,59.7602759 60.5136614,64.6318742 L60.5136614,64.6318742 L-0.970606656,65.0059233 C-1.35794023,58.3428017 2.10523466,52.7560051 8.09168218,48.4482896 C10.4419769,46.7570694 13.1709621,45.3371797 16.1802262,44.2628642 C14.3130362,42.0374247 12.8596244,39.3457674 11.9675949,36.3529948 C10.7621582,36.2342662 9.69515851,35.6352858 8.86223609,34.6834125 C7.8991321,33.5827663 7.25557207,31.9905416 7.13352235,30.1748868 C7.01480666,28.4083106 7.41271017,26.7783902 8.12841627,25.5650687 C8.94364742,24.1830245 10.1610112,23.3399258 11.5209751,23.2409781 C13.3841896,17.0792496 17.3497663,12.1154367 22.4379249,9.67164596 C22.4363955,8.76026079 22.8208933,7.82210932 23.5572952,6.8881386 C23.8861162,6.43077114 24.2784471,6.02227351 24.712411,5.68220638 C25.6554608,4.92510047 26.6026663,4.43759928 27.5998627,4.28438711 C28.8704937,4.08916366 30.2704463,4.5621904 31.4098252,4.98798323 C31.5350503,5.03478059 31.6556629,5.08117681 31.7708188,5.12434217 L31.773,5.125 L31.7328238,5.06986799 C31.6049481,4.91301969 31.4169854,4.77805538 31.224068,4.6386025 L31.1274517,4.56837991 C30.2693011,3.92723908 29.6063784,3.31549031 29.2999486,2.66883657 C28.9714426,1.97559594 28.9327666,1.21835456 29.4551739,0.307920302 C29.7525602,-0.210354645 30.1639001,-0.561086278 30.6499541,-0.77184001 Z",
    id: "shadow",
    stroke: "#F6F6F6",
    strokeWidth: 2,
    fill: "#29A3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7215819,64 C46.6503987,64 56.5741907,64 59.4929577,64 C58.8926098,52.3247985 46.1593903,42.9870914 29.7215819,42.9870914 C21.5026777,42.9870914 14.0618564,45.3842711 8.67576125,49.2599864 C3.28966606,53.1357016 0,58.0858579 0,64 C3.7685196,64 13.6757136,64 29.7215819,64 Z",
    id: "Oval",
    fill: "#29A3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7215819,64 C46.6503987,64 56.5741907,64 59.4929577,64 C58.8926098,52.3247985 46.1593903,42.9870914 29.7215819,42.9870914 C21.5026777,42.9870914 19.0386267,42.6788098 13.6525315,46.554525 C10.0618013,49.1383352 15.4181515,54.9534935 29.7215819,64 Z",
    id: "Oval",
    fill: "#208AB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6669644,9.01408451 C37.8921024,9.01408451 44.8067062,15.486429 46.7918053,24.2566464 C46.975167,24.2447537 47.1597574,24.2521396 47.3448335,24.2791977 C49.4489694,24.5869067 50.8190959,27.3208603 50.4050909,30.3856954 C50.0409354,33.0815004 48.417723,35.135374 46.6001827,35.3815479 C44.3920577,43.7514855 37.6461804,49.8425849 29.6669644,49.8425849 C21.6816972,49.8425849 14.9316402,43.7422435 12.7282863,35.3613576 C12.6030495,35.3906339 12.4750902,35.4094196 12.3449851,35.4188857 C10.22534,35.5730845 8.33881032,33.1952508 8.13127198,30.1078371 C7.9237944,27.0204191 9.47388721,24.3925625 11.5935308,24.2383425 C11.9110584,24.2152432 12.2233547,24.2489645 12.5255592,24.3333799 C14.4863347,15.524769 21.417501,9.01408451 29.6669644,9.01408451 Z",
    id: "Combined-Shape",
    fill: "#F4C6A3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 0.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Yeux",
    transform: "translate(21.633803, 24.338028)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#303030",
    cx: 2.25352113,
    cy: 2.25352113,
    r: 2.25352113
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    cx: 1.8028169,
    cy: 1.8028169,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#303030",
    cx: 13.971831,
    cy: 2.25352113,
    r: 2.25352113
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    cx: 13.5211268,
    cy: 1.8028169,
    r: 1
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#D09A94",
    cx: 19.8309859,
    cy: 31.5492958,
    rx: 3.6056338,
    ry: 1.8028169
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#D09A94",
    cx: 38.7605634,
    cy: 31.5492958,
    rx: 3.6056338,
    ry: 1.8028169
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#29A3D5",
    cx: 29.2957746,
    cy: 39.2112676,
    r: 5.85915493
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#208AB0",
    cx: 29.7464789,
    cy: 39.6619718,
    r: 2.70422535
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3225296,0.805609113 C31.8119925,-1.79017781 37.8591549,2.32206521 37.8591549,6.94798142 C37.8591549,11.5738976 34.1338536,15.3239437 29.5384615,15.3239437 C29.2671347,15.3239437 29.0065763,15.3192274 28.7564606,15.3093996 L28.6094229,15.3193632 L28.6094229,15.3193632 L28.3943662,15.3239437 C27.8896121,15.3239437 27.4024759,15.2485124 26.9436152,15.1083076 C25.0148669,14.7093802 24.01361,13.7105417 23.6282849,11.7342476 C23.5032918,11.2997124 23.4366197,10.8407408 23.4366197,10.3661972 C23.4366197,10.2532096 23.4403994,10.1411048 23.4478392,10.0300024 C23.4405815,9.81098867 23.4366197,9.58236977 23.4366197,9.3451433 C23.4366197,8.93457629 23.7809766,8.21509337 24.3551747,7.49153793 C24.6317505,7.10284117 24.9633864,6.75598264 25.3384493,6.46199865 L25.4614198,6.36948576 C26.1276095,5.82843949 26.9141058,5.40148302 27.7517237,5.27278897 C29.912356,4.94082312 32.4709574,6.97941626 32.9806186,6.14158131 C34.2640785,4.0316943 28.8330667,3.40139604 30.3225296,0.805609113 Z",
    id: "Combined-Shape",
    fill: "#3D231A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBebeHomme);
export default __webpack_public_path__ + "static/media/BebeHomme.283e1856da98d1d2e92879fd88fedd52.svg";
export { ForwardRef as ReactComponent };